import React from "react";
import { withStyles } from "@material-ui/styles";
import { map } from "lodash";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Popper from "@material-ui/core/Popper";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import MenuElement from "./MenuElement";
import CustomSignOut from "../Authentication/CustomSignOut";
import AboutLuke from "./AboutLuke";
import { ENV, TFI } from "../../client-config";
import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  menu: {
    backgroundColor: colors.white,
    padding: 0,
    boxShadow: `0px 2px 4px 0px ${colors.black54}`,
  },
};

const TopBarMenu = (props) => {
  const { classes, menu } = props;
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (
      event &&
      anchorRef.current &&
      anchorRef.current.contains(event.target)
    ) {
      return;
    }
    setOpen(false);
  };

  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      {ENV === TFI && (
        <img
          src={images.tfiLogo}
          alt="tfi_logo"
          height="50px"
          style={{ marginRight: "20px" }}
        />
      )}
      <Grid
        container
        style={{ cursor: "pointer" }}
        ref={anchorRef}
        onClick={handleToggle}
      >
        {props.children}
      </Grid>
      <Popper open={open} anchorEl={anchorRef.current} style={{ zIndex: 5 }}>
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList className={classes.menu}>
            {map(menu, (item) =>
              item === "logout" ? (
                <CustomSignOut key={item} item={item} />
              ) : item === "aboutLuke" ? (
                <AboutLuke key={item}>
                  <MenuElement item={item} blockClick closeMenu={handleClose} />
                </AboutLuke>
              ) : (
                <MenuElement key={item} item={item} closeMenu={handleClose} />
              )
            )}
          </MenuList>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

export default withStyles(styles)(TopBarMenu);
